import React from "react";
import LegalShell, { Section } from "@/pages/LegalShell";

export default function MentionsLegalesPage() {
    return (
        <LegalShell
            overline="Mentions légales"
            title="Mentions légales."
            subtitle="Conformément aux dispositions des articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN)."
        >
            <Section title="Éditeur du site" id="editeur">
                <p>
                    Le site <b>renforteo.fr</b> est édité par la société <b>Renforteo</b>.
                </p>
                <ul className="list-disc pl-6 space-y-1.5">
                    <li>Siège social : 41 rue Jean Moulin, 69300 Caluire-et-Cuire, France</li>
                    <li>SIRET : 521 636 167 00046</li>
                    <li>Numéro de TVA intracommunautaire : disponible sur demande à contact@renforteo.fr</li>
                    <li>E-mail : contact@renforteo.fr</li>
                    <li>Directeur de la publication : le représentant légal de Renforteo</li>
                </ul>
            </Section>

            <Section title="Hébergement" id="hebergement">
                <p>
                    Le site est hébergé sur une infrastructure cloud conforme aux exigences RGPD,
                    localisée dans l'Union européenne. Les données sont stockées sur des serveurs
                    sécurisés opérés par nos prestataires techniques (base de données MongoDB,
                    stockage objet Emergent, service e-mail Resend, paiements Stripe).
                </p>
                <p>
                    Pour toute question relative à l'hébergement ou à la disponibilité du service,
                    contactez contact@renforteo.fr.
                </p>
            </Section>

            <Section title="Propriété intellectuelle" id="propriete">
                <p>
                    L'ensemble des éléments présents sur le site (textes, logos, illustrations,
                    interfaces, code source original) est protégé par le droit d'auteur français
                    et international. Toute reproduction ou représentation, totale ou partielle,
                    sans autorisation écrite préalable de Renforteo est interdite.
                </p>
                <p>
                    Les visuels de mise en scène des métiers utilisés sur le site sont issus de
                    banques d'images sous licence libre (Pexels, Unsplash) — leur crédit est
                    attribué à leurs auteurs respectifs.
                </p>
            </Section>

            <Section title="Données personnelles" id="rgpd-lien">
                <p>
                    Le traitement des données personnelles est détaillé dans notre{" "}
                    <a href="/confidentialite" className="text-[#F5A623] font-semibold">
                        Politique de confidentialité
                    </a>
                    , conformément au Règlement (UE) 2016/679 (RGPD) et à la loi française
                    Informatique et Libertés modifiée.
                </p>
            </Section>

            <Section title="Cookies" id="cookies">
                <p>
                    Renforteo utilise exclusivement des <b>cookies strictement nécessaires</b> au
                    fonctionnement du service (session utilisateur, protection CSRF). Aucun cookie
                    publicitaire ni de mesure d'audience tiers n'est déposé sans consentement.
                </p>
            </Section>

            <Section title="Droit applicable" id="droit">
                <p>
                    Le présent site et les relations contractuelles qui en découlent sont soumis
                    au droit français. En cas de litige, et après échec d'une résolution amiable,
                    les tribunaux compétents sont ceux de Lyon.
                </p>
            </Section>
        </LegalShell>
    );
}
